import {
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

import StyledButton from '../../components/StyledButton';

type AlertModalState<T> = {
  isOkDisabled?: boolean | ((state: T | null) => boolean);
  onCancel?: Runnable;
  onOk: Consumer<T | null>;
  message?: string;
};

/**
 * アラートダイアログフック
 */
export const useAlertModal = <T extends object>() => {
  const [state, setState] = React.useState<T | null>(null);
  const { isOpen, onClose, onOpen } = useDisclosure();

  const handleClose = () => {
    onClose();
    setState(null);
  };

  const handleOpen = (initialState?: T) => {
    setState(initialState || null);
    onOpen();
  };

  const AlertModal: React.FunctionComponent<AlertModalState<T>> = (props) => {
    return (
      <Modal isOpen={isOpen} onClose={handleClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader as={HStack}>
            <FiAlertCircle />
            <Text>アラート</Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>{props.message}</ModalBody>
          <ModalFooter justifyContent="space-evenly">
            <StyledButton
              onClick={props.onCancel || handleClose}
              colorScheme="gray"
            >
              キャンセル
            </StyledButton>
            <StyledButton
              colorScheme="red"
              isDisabled={
                typeof props.isOkDisabled === 'function'
                  ? props.isOkDisabled(state)
                  : props.isOkDisabled
              }
              onClick={() => {
                props.onOk(state);
                handleClose();
              }}
            >
              OK
            </StyledButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };

  return { AlertModal, onClose: handleClose, onOpen: handleOpen };
};
